import { Actions as ModalActions } from "@/store/modals/slice";
import { toast } from "react-toastify";
import { analyticsAction } from "@/utils/analytics";
import { showConfirmToast } from "@/components/Toast/Confirm";
import { getReduxStore } from "@/store";

const PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY =
  "prefs:disable_manual_notify_prompt";

const isDisabled = () => {
  return !!localStorage.getItem(PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY);
};

const disable = () => {
  localStorage.setItem(PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY, 1);
  analyticsAction({
    category: "settings",
    action: "manual_reminders_off",
  });
};
const enable = () => {
  localStorage.removeItem(PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY);
  analyticsAction({
    category: "settings",
    action: "manual_reminders_on",
  });
};
const promptForNotification = (payload) => {
  return new Promise((res) => {
    const reduxStore = getReduxStore();
    if (!reduxStore || isDisabled()) {
      return res();
    }
    const i18n = window.__i18n;
    let toastId;
    const yes = () => {
      analyticsAction({
        category: "reminders",
        action: "remind_manual_yes",
      });
      toast.dismiss(toastId);
      reduxStore.dispatch(ModalActions.openSendNotification(payload));
      res();
    };
    const no = () => {
      toast.dismiss(toastId);
      analyticsAction({
        category: "reminders",
        action: "remind_manual_ni",
      });
      res();
    };
    const nomore = () => {
      toast.dismiss(toastId);
      disable();
      toast(i18n.t("common:enable_manual_notify_prompt_settings_tip"), {
        hideProgressBar: true,
        autoClose: 3000,
        position: "bottom-left",
        pauseOnHover: true,
      });
      analyticsAction({
        category: "reminders",
        action: "remind_manual_dontask",
      });
      res();
    };
    toastId = showConfirmToast({
      componentProps: {
        message: i18n.t("common:manual_notify_prompt"),
        onConfirm: yes,
        onReject: no,
        extraActionText: i18n.t("common:show_no_more"),
        onExtraAction: nomore,
      },
      toastArgs: {
        onClose: res,
      },
    });
  });
};

export const ManualExternalNotificationsPromptService = {
  isDisabled,
  prompt: promptForNotification,
  disable,
  enable,
};
